import type { ComponentStyleConfig } from "@chakra-ui/react";

export const FormLabel: ComponentStyleConfig = {
  baseStyle: {
    fontSize: "0.75em",
    fontWeight: "light",
  },
};
